import { Ref, ref, set, watch } from "@vue/composition-api";
import { uniq } from "lodash-es";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";

export default function useUserFollowings(items: Ref<{ userId: string }[]>) {
  const { authUser } = useAuthUser();
  const followedUserIds = ref<Record<string, boolean>>({});
  const uniqueUserIds = new Set();

  const updateFollowedUsers = async () => {
    if (!authUser.value) return;
    const userIds = items.value?.map(i => i.userId) || [];
    const newUserIds = userIds.filter(id => !uniqueUserIds.has(id));

    if (!newUserIds.length) return;

    const newUniqueUserIds = uniq(newUserIds);
    const followers = await providers.FollowingsProvider.searchFollowings({ ids: newUniqueUserIds }, ["userId"]);
    const newFollowedUserIds = followers.reduce<Record<string, boolean>>((acc, u) => {
      acc[u.userId] = true;
      return acc;
    }, {});
    followedUserIds.value = Object.assign(newFollowedUserIds, followedUserIds.value);
    newUniqueUserIds.forEach(userId => uniqueUserIds.add(userId));
  };

  const handleToggleFollow = (userId: string, followStatus: boolean) => {
    set(followedUserIds.value, userId, followStatus);
  };

  watch(items, () => updateFollowedUsers());

  return {
    followedUserIds,
    handleToggleFollow,
  };
}
